import * as Types from '../actions';

export function initQB(
  payload: Types.QBInitActionParams
): Types.QBInitRequestAction {
  return { type: Types.QB_INIT_REQUEST, payload };
}

export type QBInitActionCreator = typeof initQB;

export function initQBFailed(error: string): Types.QBInitFailureAction {
  return { type: Types.QB_INIT_FAILURE, error };
}

export function initQBSuccess(): Types.QBInitSuccessAction {
  return { type: Types.QB_INIT_SUCCESS };
}

export function initJanus(payload: {
  region: string;
  then?: VoidFunction;
}): Types.JanusInitRequestAction {
  return { type: Types.JANUS_INIT_REQUEST, payload };
}

export type JanusInitActionCreator = typeof initJanus;

export function initJanusSuccess(
  client: QBVideoConferencingClient
): Types.JanusInitSuccessAction {
  return { type: Types.JANUS_INIT_SUCCESS, payload: { client } };
}

export function initJanusFailure(error: string): Types.JanusInitFailureAction {
  return { type: Types.JANUS_INIT_FAILURE, error };
}

export function createSession(
  then?: VoidFunction
): Types.CreateSessionRequestAction {
  return {
    type: Types.CLIENT_CREATE_SESSION_REQUEST,
    payload: { then },
  };
}

export type CreateSessionActionCreator = typeof createSession;

export function createSessionSuccess(): Types.CreateSessionSuccessAction {
  return { type: Types.CLIENT_CREATE_SESSION_SUCCESS };
}

export function createSessionFailure(
  error: string
): Types.CreateSessionFailureAction {
  return { type: Types.CLIENT_CREATE_SESSION_FAILURE, error };
}

export function destroySession(
  payload: {
    then?: VoidFunction;
    catch?: (reason?: any) => void;
  } = {}
): Types.DestroySessionRequestAction {
  return { type: Types.CLIENT_DESTROY_SESSION_REQUEST, payload };
}

export type DestroySessionActionCreator = typeof destroySession;

export function destroySessionSuccess(): Types.DestroySessionSuccessAction {
  return { type: Types.CLIENT_DESTROY_SESSION_SUCCESS };
}

export function destroySessionFailure(
  error: string
): Types.DestroySessionFailureAction {
  return { type: Types.CLIENT_DESTROY_SESSION_FAILURE, error };
}

export function attachPlugin(payload: {
  isRemote: boolean;
  userId: any;
  then?: (action: Types.ClientAttachPluginSuccessAction) => void;
}): Types.ClientAttachPluginRequestAction {
  return { type: Types.CLIENT_ATTACH_PLUGIN_REQUEST, payload };
}

export type AttachPluginActionCreator = typeof attachPlugin;

export function attachPluginSuccess(payload: {
  plugin: PluginHandleEmitter;
  userId: any;
  isRemote: boolean;
}): Types.ClientAttachPluginSuccessAction {
  return { type: Types.CLIENT_ATTACH_PLUGIN_SUCCESS, payload };
}

export function attachPluginFailure(
  error: string
): Types.ClientAttachPluginFailureAction {
  return { type: Types.CLIENT_ATTACH_PLUGIN_FAILURE, error };
}

export function detachPlugin(
  payload: {
    then?: VoidFunction;
    catch?: (reason?: any) => void;
  } = {}
): Types.ClientDetachPluginRequestAction {
  return { type: Types.CLIENT_DETACH_PLUGIN_REQUEST, payload };
}

export type DetachPluginActionCreator = typeof detachPlugin;

export function detachPluginSuccess(): Types.ClientDetachPluginSuccessAction {
  return { type: Types.CLIENT_DETACH_PLUGIN_SUCCESS };
}

export function detachPluginFailure(
  error: string
): Types.ClientDetachPluginFailureAction {
  return { type: Types.CLIENT_DETACH_PLUGIN_FAILURE, error };
}

export function joinRoom(payload: {
  roomId: string;
  then?: VoidFunction;
}): Types.ClientJoinRequestAction {
  return { type: Types.CLIENT_JOIN_REQUEST, payload };
}

export type JoinRoomActionCreator = typeof joinRoom;

export function joinRoomSuccess(): Types.ClientJoinSuccessAction {
  return { type: Types.CLIENT_JOIN_SUCCESS };
}

export function joinRoomFailure(error: string): Types.ClientJoinFailureAction {
  return { type: Types.CLIENT_JOIN_FAILURE, error };
}

export function leaveRoom(
  payload: {
    then?: VoidFunction;
    catch?: (reason?: any) => void;
  } = {}
): Types.ClientLeaveRequestAction {
  return { type: Types.CLIENT_LEAVE_REQUEST, payload };
}

export type LeaveRoomActionCreator = typeof leaveRoom;

export function leaveRoomSuccess(): Types.ClientLeaveSuccessAction {
  return { type: Types.CLIENT_LEAVE_SUCCESS };
}

export function leaveRoomFailure(
  error: string
): Types.ClientLeaveFailureAction {
  return { type: Types.CLIENT_LEAVE_FAILURE, error };
}

export function listRoomParticipants(
  then?: (action: Types.ListRoomParticipantsSuccessAction) => void
): Types.ListRoomParticipantsRequestAction {
  return {
    type: Types.LIST_PARTICIPANTS_REQUEST,
    payload: { then },
  };
}

export type ListRoomParticipantsActionCreator = typeof listRoomParticipants;

export function listRoomParticipantsSuccess(
  payload: Participant[]
): Types.ListRoomParticipantsSuccessAction {
  return { type: Types.LIST_PARTICIPANTS_SUCCESS, payload };
}

export function listRoomParticipantsFailure(
  error: string
): Types.ListRoomParticipantsFailureAction {
  return { type: Types.LIST_PARTICIPANTS_FAILURE, error };
}

export function toggleMuteAudio(): Types.ToggleMuteAudioRequestAction {
  return { type: Types.TOGGLE_MUTE_AUDIO_REQUEST };
}

export type ToggleMuteAudioActionCreator = typeof toggleMuteAudio;

export function toggleMuteAudioSuccess(
  muted: boolean
): Types.ToggleMuteAudioSuccessAction {
  return {
    type: Types.TOGGLE_MUTE_AUDIO_SUCCESS,
    payload: { muted },
  };
}

export function toggleMuteAudioFailure(
  error: string
): Types.ToggleMuteAudioFailureAction {
  return { type: Types.TOGGLE_MUTE_AUDIO_FAILURE, error };
}

export function toggleMuteVideo(): Types.ToggleMuteVideoRequestAction {
  return { type: Types.TOGGLE_MUTE_VIDEO_REQUEST };
}

export type ToggleMuteVideoActionCreator = typeof toggleMuteVideo;

export function toggleMuteVideoSuccess(
  muted: boolean
): Types.ToggleMuteVideoSuccessAction {
  return {
    type: Types.TOGGLE_MUTE_VIDEO_SUCCESS,
    payload: { muted },
  };
}

export function toggleMuteVideoFailure(
  error: string
): Types.ToggleMuteVideoFailureAction {
  return { type: Types.TOGGLE_MUTE_VIDEO_FAILURE, error };
}

export function toggleScreenSharing(): Types.ToggleScreenSharingRequestAction {
  return { type: Types.TOGGLE_SCREENSHARE_REQUEST };
}

export type ToggleScreenSharingActionCreator = typeof toggleScreenSharing;

export function toggleScreenSharingSuccess(
  enabled: boolean
): Types.ToggleScreenSharingRequestSuccess {
  return {
    type: Types.TOGGLE_SCREENSHARE_SUCCESS,
    payload: { enabled },
  };
}

export function toggleScreenSharingFailure(
  error: string
): Types.ToggleScreenSharingFailureAction {
  return { type: Types.TOGGLE_SCREENSHARE_FAILURE, error };
}

export function iceRestart(payload: {
  isRemote: boolean;
  userId?: number;
}): Types.IceRestartRequest {
  return { type: Types.ICE_RESTART_REQUEST, payload };
}

export function iceRestartSuccess(): Types.IceRestartSuccess {
  return { type: Types.ICE_RESTART_SUCCESS };
}

export function iceRestartFailure(error: string): Types.IceRestartFailure {
  return { type: Types.ICE_RESTART_FAILURE, error };
}

export function dispose(): Types.QBDisposeRequestAction {
  return { type: Types.QB_DISPOSE_REQUEST };
}

export type QBDisposeActionCreator = typeof dispose;

export function disposeSuccess(): Types.QBDisposeSuccessAction {
  return { type: Types.QB_DISPOSE_SUCCESS };
}

export function disposeFailure(error: string): Types.QBDisposeFailureAction {
  return { type: Types.QB_DISPOSE_FAILURE, error };
}

export function gotLocalStream(stream: MediaStream): Types.LocalStreamEvent {
  return {
    type: Types.LOCAL_STREAM,
    payload: { stream },
  };
}

export function gotRemoteStream(
  stream: MediaStream,
  userId: number
): Types.RemoteStreamEvent {
  return {
    type: Types.REMOTE_STREAM,
    payload: { stream, userId },
  };
}

export function participantJoined(payload: {
  audio_codec: string;
  display?: string;
  id: number;
  talking: boolean;
  video_codec: string;
}): Types.ParticipantJoinedEvent {
  return { type: Types.PARTICIPANT_JOINED, payload };
}

export function participantLeft(userId: number): Types.ParticipantLeftEvent {
  return {
    type: Types.PARTICIPANT_LEFT,
    payload: { userId },
  };
}

export function conferencingClientError(
  error: string
): Types.ConferencingClientError {
  return { type: Types.CONFERENCING_CLIENT_ERROR, error };
}
